var exports = {
  "$P": "StreamSettingsMenuContent.module__modeItem___WXlkUl",
  "Q6": "StreamSettingsMenuContent.module__modeLabelColumn___WXlkUl",
  "i2": "StreamSettingsMenuContent.module__modeTitle___WXlkUl",
  "ED": "StreamSettingsMenuContent.module__modeDescription___WXlkUl",
  "nM": "StreamSettingsMenuContent.module__row___WXlkUl",
  "xZ": "StreamSettingsMenuContent.module__rowLabel___WXlkUl",
  "BE": "StreamSettingsMenuContent.module__premiumBadge___WXlkUl",
  "JV": "StreamSettingsMenuContent.module__audioDeviceLabel___WXlkUl",
  "ue": "StreamSettingsMenuContent.module__audioDeviceName___WXlkUl",
  "Ky": "StreamSettingsMenuContent.module__audioDeviceSubtext___WXlkUl",
  "HA": "StreamSettingsMenuContent.module__compactLiveGroupLabel___WXlkUl",
  "Au": "StreamSettingsMenuContent.module__audioDeviceIcon___WXlkUl",
};

module.exports = exports;
